import React, { memo } from 'react';
import PropTypes from 'prop-types';

import MuiButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import { getBackgroundColor, getBorderColor } from '../../utils/colors';

const StyledButton = withStyles((theme) => ({
  root: {
    minWidth: (props) => props?.width ? props.width : '100px',
    height: (props) => props?.height ? props.height : '40px',
    textTransform: 'none',
    fontWeight: 'bold',
    borderRadius: '8px',
    fontSize: (props) => props?.fontSize ? props.fontSize : '12px',
    border: (props) => `1px solid ${getBorderColor(props.disabled ? 'grey' : props.color)}`,
    background: (props) => getBackgroundColor(props.disabled ? 'grey' : props.color),
    cursor: (props) => props.disabled ? 'default' : 'pointer',
    '&:hover': {
      background: props => getBackgroundColor(props.disabled ? 'grey' : props.color)
    },
    padding: '4px 12px !important'
    // '&:disabled': {
    //   backgroundColor: 'rgba(0, 0, 0, 0.12)',
    //   borderColor: 'rgba(0, 0, 0, 0.12)',
    //   color: 'rgba(0, 0, 0, 0.26)'
    // }
  }
}))(MuiButton);

const ColorButton = (props) => {
  const {
    text,
    color,
    onClick,
    disabled,
    loading,
    outlined,
    height,
    fontSize,
    className
  } = props;

  return (
    <StyledButton
      onClick={onClick}
      color={color}
      variant={outlined ? 'outlined' : 'text'}
      disabled={disabled}
      loading={loading}
      height={height}
      fontSize={fontSize}
      className={className}
    >
      { loading ? <CircularProgress size={24} /> : text}
    </StyledButton>
  );
};

ColorButton.propTypes = {
  text: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  color: PropTypes.oneOf(['green', 'blue', 'red', 'orange', 'grey'])
};

export default memo(ColorButton);
